import AbstractView from "../../../../../shared/src/ranj/equalture/view/AbstractView";
import PuzzleModel from "../model/PuzzleModel";
import GameElementSkinFactory from "./GameElementSkinFactory";
import LocationView from "./LocationView";

export default class PuzzleView extends AbstractView {

    /**
     * 
     * @param {createjs.Container} target 
     * @param {PuzzleModel} puzzleModel 
     * @param {GameElementSkinFactory} elementFactory 
     * @param {createjs.Rectangle} viewport 
     */
    constructor(target, puzzleModel, elementFactory, viewport) {
        super(target);
        this._model = puzzleModel;
        this._elementFactory = elementFactory;
        this._viewport = viewport;
        this._locationView;
        this._sequenceTimeline;
        this._build();

        this._preventClicks = false;
    }

    destroy() {
        super.destroy();
        if (this._sequenceTimeline) {
            this._sequenceTimeline.removeAllEventListeners();
            this._sequenceTimeline.gotoAndStop(0);
            this._sequenceTimeline = null;
        }

        this._locationView.destroy();
    }

    get target() {
        return this._target;
    }

    set viewport(rectangle) {
        if (rectangle != null) {
            this._viewport = rectangle;
            if (this._scrollpane) {
                this._scrollpane.setViewPort(this._viewport);
                this._centerLocation();
            }
        }
    }

    _centerLocation() {
        const b = this._locationBounds, vp = this._viewport;
        const offset = this._model.initialOffset;
        this._scrollpane.setScrollPosition(-(b.width - vp.width) / 2 + offset.x, -(b.height - vp.height) / 2 + offset.y);
    }

    _build() {
        this._locationView = new LocationView(this._elementFactory.getLocation(this._model.location));

        const sequence = this._model.sequence;
        this._locationView.spots.forEach(spot => {
            spot.button.addEventListener("click", this._buildClickHandler(spot));
            spot.button.setEnabled(false);
        });

        for (var i = 0; i < sequence.length; i++) {
            var elm = sequence[i];
            console.log(`spot${elm.spot}`);
            var spot = this._locationView.getSpotById(`spot${elm.spot}`);
            spot.item.content = this._elementFactory.getItem(elm.variation);
        }

        this._target.addChild(this._locationView.target);
    }

    _buildClickHandler(spot) {
        return _ => {
            if (this.enabled && spot.canClick() && !this.preventClicks) {
                spot.updateLastClickTime();
                spot.button.setSelected(true);
                spot.button.setEnabled(false);
                spot.button.skin.selectIndicator.selectIndicator.numberTextfield.text = `${this._model._pickedSpots.length + 1}`;
                this.dispatchEvent(PuzzleView.SELECT, spot);
            }
        }
    }

    getLastSelection() {
        if (this._model.pickedSpots.length < 1) { return null };

        return this._model.pickedSpots[this._model.pickedSpots.length - 1];
    }

    deselect(spot) {
        spot.button.setSelected(false);
        spot.button.setEnabled(true);
    }

    animateOut(duration = 200, delay = 0, callback = null, fade = false) {
        const target = this._target;
        const props = {};
        if (callback != null) {
            props.onComplete = callback;
        }
        if (fade) {
            createjs.Tween.get(this._target, props).wait(delay).to({ alpha: 0 }, duration, createjs.Ease.quadIn);
        } else {
            createjs.Tween.get(this._target, props).wait(delay).to({ y: target.y + target.getBounds().height }, duration, createjs.Ease.quadInOut);

        }
    }

    animateIn(duration = 200, delay = 0, callback = null, fade = false) {
        const props = {};
        if (callback != null) {
            props.onComplete = callback;
        }


        if (fade) {
            //this._target.alpha = 0;
            createjs.Tween.get(this._target, props)
                .wait(delay)
                .to({ alpha: 1 }, duration, createjs.Ease.quadOut);
        } else {
            this._target.alpha = 1;
            const target = this._target;
            const origY = target.y;
            target.y -= target.getBounds().height;
            createjs.Tween.get(this._target, props)
                .wait(delay)
                .to({ y: origY }, duration, createjs.Ease.quadInOut);
        }
    }

    disable() {
        this.enabled = false;
        this._locationView.spots.forEach(spot => {
            spot.button.setEnabled(false);
        });
    }

    enable() {
        this.enabled = true;
        this._locationView.spots.forEach(spot => {
            spot.button.setEnabled(true);
        });
    }

    playSequence(callback, durationAnimation = 5000, fadeInDuration = 300, fadeOutDuration = 300, delayBetweenAnimations = 1000, finalDelay = 1000) {
        this._sequenceTimeline = new createjs.Timeline({ onComplete: callback });

        const totalDurationAnimation = durationAnimation + fadeInDuration + fadeOutDuration;
        const sequence = this._model.sequence;
        for (var i = 0; i < sequence.length; i++) {
            var spot = this._locationView.getSpotById(`spot${sequence[i].spot}`);

            let tween = createjs.Tween.get(spot.item)
                .wait(i * (totalDurationAnimation + delayBetweenAnimations))
                .call((tween) => { tween.target.animate(durationAnimation, fadeInDuration, fadeOutDuration) })
                .wait(totalDurationAnimation);

            if (i == sequence.length - 1) {
                // Final delay
                tween = tween.wait(finalDelay);
            }

            this._sequenceTimeline.addTween(tween);
        }

        this._sequenceTimeline.gotoAndPlay(0);
    }

    /**
     * @param {string} text 
     * @param {boolean} isCorrect 
     */
    showFeedback(text, isCorrect) {
        this._locationView.showFeedback(text, isCorrect);
    }

    setSample(skin) {
        this._locationView.setSample(skin);
    }

    setRule(rule, useShortVariant = false) {
        this._locationView.setRule(rule, useShortVariant);
    }

    set preventClicks(value) {
        this._preventClicks = value;
    }

    get preventClicks() {
        return this._preventClicks;
    }

    set enabled(bool) {
        this._locationView.spots.forEach(spot => {
            spot.button.setEnabled(bool);
        });
        this._enabled = bool;
    }

    get enabled() {
        return this._enabled;
    }

}

PuzzleView.SELECT = "PuzzleView.SELECT";